@if (showAccountId) {
  <div class="re-summary-row-nowrap">
    <div>{{ 'general.customerData.account' | translate }}</div>
    <div>{{accountId}}</div>
  </div>
}

@if (billingAddress?.keepRecipient) {
  <div>
    @for (recipient of billingAddress.recentRecipientPersons; track recipient) {
      <div class="re-summary-row-nowrap">
        <div>{{ 'address.personalInfo.name' | translate }}</div>
        <div>{{recipient.firstname}} {{recipient.lastname}}</div>
      </div>
    }
    @if (billingAddress?.recentRecipientOrg?.nameOrg1) {
      <div class="re-summary-row-nowrap">
        <div>{{ 'address.personalInfo.name' | translate }}</div>
        <div>{{ billingAddress?.recentRecipientOrg.nameOrg1}} {{ billingAddress?.recentRecipientOrg.nameOrg2}}</div>
      </div>
    }
  </div>
}

@if (!billingAddress?.keepRecipient) {
  <div class="re-summary-row-nowrap">
    <div>{{ 'address.personalInfo.name' | translate }}</div>
    <div>{{billingAddress?.newRecipientGivenName}} {{billingAddress?.newRecipientSurname}}</div>
  </div>
}

<div class="re-summary-row-nowrap">
  <div>{{ 'address.street.title' | translate }}</div>
  <div>{{ billingAddress?.streetName }}</div>
</div>
<div class="re-summary-row-nowrap">
  <div>{{ 'address.housenumber.title' | translate }}</div>
  <div>{{ billingAddress?.houseNum }}</div>
</div>

<div class="re-summary-row-nowrap">
  <div>{{ 'address.postCode.postCodeAndCity' | translate }}</div>
  <div>{{billingAddress?.postCode}} {{billingAddress?.cityName}}</div>
</div>

<div class="re-summary-row-nowrap re-mb-0">
  <div>{{ 'address.email.title' | translate }}</div>
  <div>{{billingAddress?.email}}</div>
</div>
